export enum WEBAPP_SESSION_STORAGE_KEYS {
  SkeemaUserBrowserSession = 'SkeemaUserBrowserSession',
}

export enum WEBAPP_LOCAL_STORAGE_KEYS {
  IsPinningTutorialVisible = 'IsPinningTutorialVisible',
  IsReadyForPinningTutorial = 'IsReadyForPinningTutorial',
  FeatureFlagValues = 'FeatureFlagValues',
  PlaceholderSessionTitleCount = 'PlaceholderSessionTitleCount',
  CurrentOnboardingTutorialStepV2 = 'CurrentOnboardingTutorialStepV2Fix',
  CurrentOnboardingTutorialStepV3 = 'CurrentOnboardingTutorialStepV3',
  IsRebrandingNotificationDismissed = 'IsRebrandingNotificationDismissed',
  HasSkipperBrandingLoaded = 'HasSkipperBrandingLoaded',
  OnboardingGuidedAutoSaveSkipped = 'OnboardingGuidedAutoSaveSkipped',
  IsNewTabOverrideNotificationVisible = 'IsNewTabOverrideNotificationVisible',
  ShouldASTIncludeUserClosedTabs = 'ShouldASTIncludeUserClosedTabs',
  DidCreateProjectsFromTabgroups = 'DidCreateProjectsFromTabgroups',
  HasCompletedOnboardingInThePast = 'HasCompletedOnboardingInThePast',
  DEPRECATED_IsSurveyNotificationVisible = 'IsSurveyNotificationVisible',
  DEPRECATED_CurrentOnboardingTutorialStepV2 = 'CurrentOnboardingTutorialStepV2',
  DEPRECATED_CurrentOnboardingTutorialStep = 'CurrentOnboardingTutorialStep',

  // Grandfathered folders banner
  IsGrandfatheredFoldersBannerDismissed = 'IsGrandfatheredFoldersBannerDismissed',

  // Free plan changing announcement banner
  IsFreePlanChangingBannerDismissed = 'IsFreePlanChangingBannerDismissed',

  // Upsell banner localStorage keys
  IsUpsellBannerOct30Nov6Dismissed = 'IsUpsellBannerOct30Nov6Dismissed',
  IsUpsellBannerNov7Nov12Dismissed = 'IsUpsellBannerNov7Nov12Dismissed',
  IsUpsellBannerNov13Nov15Dismissed = 'IsUpsellBannerNov13Nov15Dismissed',
}
